import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { site } from "@/mocks/site";

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const transparent = isHome && !scrolled && !menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        transparent
          ? "bg-transparent py-4"
          : "border-b border-background-200 bg-background-50/95 py-2.5 backdrop-blur-md"
      }`}
    >
      <nav className="mx-auto flex w-full items-center justify-between px-4 md:px-6" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2.5" aria-label="513吃瓜 首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md font-heading text-lg ${
              transparent ? "bg-accent-500 text-foreground-950" : "bg-primary-500 text-background-50"
            }`}
            aria-hidden="true"
          >
            513
          </span>
          <span
            className={`font-heading text-xl leading-none tracking-wide ${
              transparent ? "text-background-50" : "text-foreground-950"
            }`}
          >
            513吃瓜
          </span>
        </Link>

        <ul className="hidden items-center gap-1 md:flex">
          {site.nav.map((item) => (
            <li key={item.key}>
              <NavLink
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `relative block rounded-md px-3.5 py-2 font-label text-sm transition-colors ${
                    transparent
                      ? isActive
                        ? "text-accent-400"
                        : "text-background-100 hover:text-accent-400"
                      : isActive
                        ? "text-primary-700"
                        : "text-foreground-700 hover:text-primary-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <Link
            to="/contact"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 font-label text-sm transition-colors md:inline-flex ${
              transparent
                ? "bg-background-50 text-foreground-950 hover:bg-accent-400"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            投稿 / 合作
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border md:hidden ${
              transparent
                ? "border-background-100/40 text-background-50"
                : "border-background-200 text-foreground-900"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <ul className="flex flex-col">
            {site.nav.map((item) => (
              <li key={item.key}>
                <NavLink
                  to={item.path}
                  end={item.path === "/"}
                  className={({ isActive }) =>
                    `block rounded-md px-3 py-3 font-label text-base ${
                      isActive ? "bg-primary-100 text-primary-700" : "text-foreground-800"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <Link
            to="/contact"
            className="mt-3 block whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center font-label text-sm text-background-50"
          >
            投稿 / 合作
          </Link>
        </div>
      ) : null}
    </header>
  );
}